module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/screwdriver-0e695daceac150e3d581fccb3a6bc397.svg";